module.exports = __webpack_public_path__ + "static/media/userdefault.114a5b66.svg";